import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../actions/navigationActions";
import * as settingsActions from "../../../../actions/settingsActions";
import * as rccActions from "../../../../actions/rccActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as rcc from "../../../../constants/rcc";
import * as resources from "../../../../constants/resources";
import * as formatHelper from "../../../../helpers/formatHelper";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgStir from "../../../../resources/img/svgicons/stir.svg";
import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";

class StirAllCanistersModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            stirringTime: this.props.stirringTime,
            stirringSpeed: this.props.stirringSpeed
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleStartStirringClick = () => {
        this.props.dispatchCloseModalAction();
        this.props.dispatchStirAllCanistersAction(Number(this.state.stirringTime), Number(this.state.stirringSpeed));
    };

    handleStirringTimeFocus = (event) => {
        event.target.select();
    };

    handleStirringTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_STIR_TIME) {
            this.setState({stirringTime: formatHelper.formatDecimal(value)});
            this.props.dispatchSetStirringTimeAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({stirringTime: rcc.RCC_MINIMAL_STIR_TIME});
            this.props.dispatchSetStirringTimeAction(rcc.RCC_MINIMAL_STIR_TIME);
        }
    };

    handleStirringSpeedFocus = (event) => {
        event.target.select();
    };

    handleStirringSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100 && value >= 1) {
            this.setState({stirringSpeed: formatHelper.formatDecimal(value)});
            this.props.dispatchSetStirringSpeedAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({stirringSpeed: this.props.stirringSpeed});
        }
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-6 flex flex-align-center-vertical">
                    <Translate className="padding-right-5" value="stirCanisters.stirringTime" />
                    <Input
                        className="primary-input col-5"
                        value={this.state.stirringTime}
                        onFocus={this.handleStirringTimeFocus}
                        onChange={this.handleStirringTimeChange}
                        onBlur={this.handleStirringTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_STIRRING_TIME)}
                        labelAfter="s"
                    />
                </div>
                <div className="col-6 flex flex-align-center-vertical flex-end">
                    <Translate className="padding-right-5" value="stirCanisters.stirringSpeed" />
                    <Input
                        className="primary-input col-5"
                        value={this.state.stirringSpeed}
                        onFocus={this.handleStirringSpeedFocus}
                        onChange={this.handleStirringSpeedChange}
                        onBlur={this.handleStirringSpeedBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_STIRRING_SPEED)}
                        labelAfter="%"
                    />
                </div>
            </React.Fragment>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    svgBefore={imgStir}
                    label={<Translate value="serviceActionsSettings.stirAllCanisters" />}
                    onClick={this.handleStartStirringClick}
                    disabled={Number(this.state.stirringTime) <= 0 || Number(this.state.stirringSpeed) <= 0}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="stirCanisters.stirAllCanisters" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        stirringSpeed: store.settings.stirringSpeed,
        stirringTime: store.settings.stirringTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.STIR_ALL_CANISTERS_MODAL));
        },
        dispatchStirAllCanistersAction: (stirringTime, stirringSpeed) => {
            dispatch(rccActions.stirAllCanisters(stirringTime, stirringSpeed));
        },
        dispatchSetStirringTimeAction: (stirringTime) => {
            dispatch(settingsActions.setStirringTime(stirringTime));
        },
        dispatchSetStirringSpeedAction: (stirringSpeed) => {
            dispatch(settingsActions.setStirringSpeed(stirringSpeed));
        }
    };
};

export default StirAllCanistersModal = connect(mapStoreToProps, mapDispatchToProps)(StirAllCanistersModal);
